export const aboutData = {
  banner: {
    image: "/images/about-banner.jpg",
    alt: "Quality",
  },
  breadcrumb: [
    { label: "HOME", href: "/" },
    { label: "ABOUT MODEPRO", href: "/about" },
  ],
  pageTitle: "ABOUT MODEPRO INDIA",
  whoWeAre: {
    image: "/images/about-we-are-img.png",
    alt: "Who We Are",
    title: "Who we are",
    paragraphs: [
      "Modepro India Pvt. Ltd was established in the year 1993. Our company is primarily engaged in the manufacture of late stage intermediates for active pharmaceutical ingredients. Over the past years, Modepro has established itself as a key partner to several European and Indian pharmaceutical companies for their requirement of advanced intermediates of API's.",
      "With our state of the art cGMP certified manufacturing facilities, our focus on research & development, our deep commitment to quality & our emphasis on customer satisfaction, Modepro is poised to become one of the leading suppliers of intermediates to the pharmaceutical industry.",
      "Our company was successfully audited by USFDA  during August, 2022.",
    ],
  },
  ourPeople: {
    image: "/images/our-people-img.png",
    alt: "Our People",
    title: "Our People",
    description:
      "We are a team of highly qualified individuals having vast experience in various areas such as chemical process development, chemical technology, Quality & manufacturing expertise. By leveraging our strengths, We are able to provide cost effective solutions for our customer's diverse requirements.",
  },
  manufacturingLocation: {
    title: "Manufacturing Location",
    location: "Kurkumbh, Pune.",
    address:
      "Plot No. D-26/1, Kurkumbh MIDC, Tal – Daund, Dist – Pune, State – Maharashtra, India  413802.",
    image: "/images/location-img.png",
    alt: "Location",
  },
  infoCards: [
    {
      id: "processdevelopment",
      title: "Process Development",
      image: "/images/pro-del-img.png",
      alt: "Process Development",
      description:
        "We have a successful track record in developing non-infringing processes and scaling them up from laboratory to kilo scale to commercial scale production. Our team of researchers have developed several innovative processes for producing intermediates of  many well known API's",
    },
    {
      id: "qms",
      title: "Quality Management Systems",
      image: "/images/cgmp.png",
      alt: "Quality Management systems",
      paragraphs: [
        "Our quality assurance & quality control departments are staffed with competent individuals & our quality systems and documentation are compliant with cGMP requirements. Our plant has been audited by several European multinational companies for compliance to cGMP for pharmaceutical intermediates based on the ICHQ7 standard.",
        "Our company was  successfully audited by USFDA during August, 2022.",
      ],
    },
    {
      id: "rip",
      title: "Respect for Intellectual Property",
      image: "/images/Property-img.png",
      alt: "Respect for Intellectual Property",
      description:
        "Our long-term relationships with multinational companies bear testimony to our strict adherence to Intellectual Property. We leverage best practices and technology to ensure confidentiality in our operations.",
    },
    {
      id: "ehs",
      title: "Environment, Health and Safety",
      image: "/images/safety-img.png",
      alt: "Environment, Health and Safety",
      description:
        "We are committed to the health and safety of our employees, the welfare of our community and environment protection. We play a proactive role in creating awareness, imparting training and minimizing pollution.",
    },
  ],
};